import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { BarChart3, Table2, Settings, LogOut } from "lucide-react";

const NAV = [
  { to: "/admin", icon: BarChart3, label: "Dashboard", end: true },
  { to: "/admin/responses", icon: Table2, label: "Responses" },
  { to: "/admin/settings", icon: Settings, label: "Settings" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#fdf7ff]">
      {/* Top nav */}
      <nav className="bg-white border-b-2 border-[#111] sticky top-0 z-50" data-testid="admin-nav">
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between h-14">
          <div className="flex items-center gap-3">
            <img 
              src="/LogoAMP.png" 
              alt="AMP Singapore Logo" 
              className="h-12 w-auto"
            />
            <span className="font-parkinsans font-medium text-lg">AMP AI READY</span>
          </div>
          <div className="flex items-center gap-1 md:gap-2">
            {NAV.map(n => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                className={({ isActive }) =>
                  `flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors border-2 ${
                    isActive
                      ? "bg-[#f5d0fe] border-[#111] shadow-[2px_2px_0px_0px_rgba(17,17,17,1)]"
                      : "border-transparent hover:bg-[#fdf7ff]"
                  }`
                }
                data-testid={`nav-${n.label.toLowerCase()}`}
              >
                <n.icon className="w-4 h-4" strokeWidth={2.5} />
                <span className="hidden md:inline">{n.label}</span>
              </NavLink>
            ))}
            <div className="ml-2 pl-2 border-l-2 border-[#e5e5e5] flex items-center gap-2">
              <span className="text-xs text-gray-500 hidden md:inline">{user?.email}</span>
              <button
                onClick={handleLogout}
                className="flex items-center gap-1 px-2 py-1.5 rounded-lg text-sm hover:bg-red-50 text-red-600 transition-colors"
                data-testid="logout-btn"
              >
                <LogOut className="w-4 h-4" strokeWidth={2.5} />
              </button>
            </div>
          </div>
        </div>
      </nav>
      <main className="max-w-7xl mx-auto px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
